import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

// Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MicrosoftSubscriptionTable from '../MicrosoftSubscriptionTable';

// Styles
import makeStyles from '@material-ui/core/styles/makeStyles';

function SubscriptionInfo({
  companyName,
  isLoading,
  subscriptionData,
  subscriptionConfirmationData,
  onChangeCompanyName,
  onConfirm,
}) {
  const classes = useStyles();
  const shouldRenderConfirmButton =
    _get(subscriptionData, ['siftSubscription', 'source']) === 'token' &&
    _isEmpty(subscriptionConfirmationData);

  const preConfirmationContent = (
    <div className={classes.buttonContainer}>
      <Button
        disabled={isLoading || _isEmpty(subscriptionData)}
        data-testid="confirm-button"
        onClick={onConfirm}
        itemType="submit"
        color="secondary"
        variant="contained"
      >
        {isLoading ? 'Loading' : 'Confirm'}
      </Button>
    </div>
  );

  const postConfirmationContent = (
    <div>
      <Typography>
        The Sift team will be in contact with next steps over the next few days when activation is
        complete. In the meantime, take a look at our{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://download.justsift.com/guide/sift-onboarding-prepare-for-sift-off.pdf"
        >
          launch guide
        </a>{' '}
        and{' '}
        <a href="https://help.justsift.com/" target="_blank" rel="noopener noreferrer">
          help center
        </a>{' '}
        to learn more about setting up Sift!
      </Typography>
    </div>
  );

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      onConfirm();
    }
  };

  return (
    <div data-testid="subscription-info">
      <MicrosoftSubscriptionTable
        companyName={companyName}
        confirmedSubscriptionData={subscriptionConfirmationData}
        subscriptionData={subscriptionData}
        handleKeyPress={handleKeyPress}
        handleChangeCompany={onChangeCompanyName}
      />
      {shouldRenderConfirmButton ? preConfirmationContent : postConfirmationContent}
    </div>
  );
}

SubscriptionInfo.propTypes = {
  companyName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  subscriptionConfirmationData: PropTypes.object.isRequired,
  onChangeCompanyName: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {},
  buttonContainer: {
    marginTop: theme.spacing(8),
  },
}));

export default SubscriptionInfo;
